@if (rotaAssignment) {
  <div class="employee-shop-assignment">
    {{ rotaAssignment.startTime | timeParse | dateFormat: 'HH:mm' }} -
    {{ rotaAssignment.endTime | timeParse | dateFormat: 'HH:mm' }}
    @for (assignment of roleAssignments; track assignment) {
      <div class="role-assignment">
        {{ assignment.role | enumParse }}:
        {{ assignment.startTime | timeParse | dateFormat: 'HH:mm' }} -
        {{ assignment.endTime | timeParse | dateFormat: 'HH:mm' }}
      </div>
    }
  </div>
}

@if (availabilityAssignment) {
  <div class="height-15px"></div>
}
@if (availabilityAssignment) {
  <div class="availability">
    Available
    {{ availabilityAssignment.startTime | timeParse | dateFormat: 'HH:mm' }} -
    {{ availabilityAssignment.endTime | timeParse | dateFormat: 'HH:mm' }}
  </div>
}